import { jsx as _jsx } from "react/jsx-runtime";
import { replaceNewLinesWithBreaks } from "../utils/create-breaks";
import styles from "./hero-subheading.module.css";
export function HeroSubheading({ subheading  }) {
    return /*#__PURE__*/ _jsx("h2", {
        className: styles["subheading"],
        "data-testid": "hero-subheading",
        children: replaceNewLinesWithBreaks(subheading)
    });
}
